export default "__VITE_ASSET__972459de__"